export interface SummitStatusInput {
  rank: number;
  totalUsers: number;
  score: number;
  cutoffPercent?: number;
}

export interface SummitStatus {
  isQualified: boolean;
  rank: number;
  percentile: number;
  cutoffRank: number;
  pointsToQualify: number;
}

export function computeSummitStatus({
  rank,
  totalUsers,
  score,
  cutoffPercent = 0.1,
}: SummitStatusInput): SummitStatus {
  const cutoffRank = Math.ceil(totalUsers * cutoffPercent);
  const isQualified = rank <= cutoffRank;
  const percentile = totalUsers > 0 ? rank / totalUsers : 1;
  return {
    isQualified,
    rank,
    percentile,
    cutoffRank,
    pointsToQualify: 0, // placeholder V1
  };
}
